export default "__VITE_ASSET__3b37166e__"